(function () {
  /**
   * @ngdoc module
   * @name akitabox.mobile.constants
   */
  var module = angular.module("akitabox.mobile.constants", []);

  /**
   * Account storage key
   *
   * @type {String}
   */
  var KEY_ACCOUNT = "account";

  module.constant("KEY_ACCOUNT", KEY_ACCOUNT);

  /**
   * Building storage key
   *
   * @type {String}
   */
  var KEY_BUILDING = "building";

  module.constant("KEY_BUILDING", KEY_BUILDING);

  /**
   * Building storage key
   *
   * @type {String}
   */
  var KEY_BUILDING_LIST = "building-list";

  module.constant("KEY_BUILDING_LIST", KEY_BUILDING_LIST);

  /**
   * Side menu navigation component ID
   *
   * @type {String}
   */
  var SIDE_MENU_NAV_ID = "side-menu";

  module.constant("SIDE_MENU_NAV_ID", SIDE_MENU_NAV_ID);

  /**
   * Maximum number of list items per recent activity request
   *
   * @type {number}
   */
  var RECENT_ACTIVITY_REQUEST_LIMIT = 20;

  module.constant(
    "RECENT_ACTIVITY_REQUEST_LIMIT",
    RECENT_ACTIVITY_REQUEST_LIMIT
  );
})();
